const Env = {
  reCaptchaSiteKey: "6Lf5LxopAAAAALXErlTeGxlWy_x6M8RlKlJzZ4RB",
  server: document.location.protocol + "//api.linventaire.app",
  // Public API documentation (built from /api-docs into the frontend build)
  apiDocs: "/docs/index.html",
  // User manual (built from /user-docs into the frontend build)
  userDocs: "/manuals/index.html",
  version: "1.3.4",
};

export default Env;
